import { NavLink } from "react-router-dom";
import {
  Home,
  ShoppingCart,
  FileText,
  CreditCard,
  XCircle,
  Settings,
  Users,
  Store,
  Building2,
  UserCog,
  Package,
} from "lucide-react";
import type { AuthUser } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";

interface SidebarProps {
  user: AuthUser;
}

const NAV_OPERADOR = [
  { to: "/",                label: "Inicio",         icon: Home },
  { to: "/ventas",          label: "Ventas",         icon: ShoppingCart },
  { to: "/cuentas-cobro",   label: "Cuentas cobro",  icon: FileText },
  { to: "/clientes",        label: "Clientes",       icon: Users },
];

const NAV_ADMIN = [
  { to: "/",                       label: "Inicio",         icon: Home },
  { to: "/admin/kanban",           label: "Kanban",         icon: FileText },
  { to: "/ventas",                 label: "Ventas",         icon: ShoppingCart },
  { to: "/pagos",                  label: "Pagos",          icon: CreditCard },
  { to: "/anulaciones",            label: "Anulaciones",    icon: XCircle },
  { to: "/clientes",               label: "Clientes",       icon: Users },
  { to: "/admin/tiendas",          label: "Tiendas",        icon: Store },
  { to: "/admin/financieras",      label: "Financieras",    icon: Building2 },
  { to: "/admin/vendedores",       label: "Vendedores",     icon: UserCog },
  { to: "/admin/productos",        label: "Productos",      icon: Package },
  { to: "/admin/usuarios",         label: "Usuarios",       icon: Users },
  { to: "/config",                 label: "Configuración",  icon: Settings },
];

export function Sidebar({ user }: SidebarProps) {
  const nav = user.rol === "admin_central" ? NAV_ADMIN : NAV_OPERADOR;

  return (
    <aside className="hidden md:flex md:w-60 lg:w-64 flex-col bg-bg-card border-r border-border sticky top-0 h-screen">
      <div className="p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <div className="size-8 rounded-md bg-brand grid place-items-center text-white font-bold">
            L
          </div>
          <span className="font-semibold">Liquidación</span>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-0.5">
        {nav.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors",
                isActive
                  ? "bg-brand/10 text-brand font-medium"
                  : "text-fg-secondary hover:bg-bg hover:text-fg",
              )
            }
          >
            <Icon className="size-4" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
